import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  gap: 4.5rem;

  margin: 3rem 0;
`;

export { Container };
